<div class="contenedorInt">
    <div class="contenedorIntHeader">
        <header class="FheaderInt" id="HligasSalud">
            <div class="textHeader flx">
                <div class="dUno dmMedio"></div>
                <div class="dCincoM dtOcho dmOnce">
                    <h1>LIGAS DE INTERÉS</h1>
                    <p> Mantenerte informado también puede ayudarte a cuidar de ti y los tuyos. Por medio de estas ligas podrás obtener información relevante y actual del sector de la salud.</p>
                </div>
                <div class="dCinco dtDos dmMedio"></div>
            </div>
        </header>
    </div>
    
<div class="contenedorIntSub">
    <div class="FlgsSld dDoce">
        <div class="FlgsSldInt flx">
            <div class="dCuatro dtSeis dmDoce">
                <a href="http://www.laboratoriosbest.com.mx/farmacovigilancia.html" target="_blank" rel="noopener"><span> www.laboratoriosbest.com.mx </span></a>
                <br/>
                <p>Farmacovigilancia</p>
            </div>
            <div class="dCuatro dtSeis dmDoce">
                <a href="https://www.gob.mx/cofepris" target="_blank" rel="noopener"><span> www.gob.mx/cofepris </span></a>
                <br/>
                <p>Comisión Federal para la Protección contra Riesgos Sanitarios</p>
            </div>
            <div class="dCuatro dtSeis dmDoce">
                        <a href="http://www.facmed.unam.mx" target="_blank" rel="noopener"><span> www.facmed.unam.mx </span></a>
                        <br/>
                        <p>Facultad de Medicina de la UNAM</p>
            </div>
            <div class="dCuatro dtSeis dmDoce Fblanco">
                        <a href="https://www.medigraphic.com" target="_blank" rel="noopener"><span> www.medigraphic.com </span></a>
                        <br/>
                        <p>Literatura Biomédica</p>
            </div>
            <div class="dCuatro dtSeis dmDoce Fblanco">
                        <a href="https://www.gob.mx/salud" target="_blank" rel="noopener"><span> www.gob.mx/salud </span></a>
                        <br/>
                        <p>Secretaría de Salud</p>
            </div>

            <div class="dCuatro dtSeis dmDoce Fblanco">
                        <a href="http://www.cedulaprofesional.sep.gob.mx" target="_blank" rel="noopener"><span> www.cedulaprofesional.sep.gob.mx </span></a>
                            <br/>
                        <p>Consulta de Cedulas Profesionales</p>
            </div>
            <div class="dCuatro dtSeis dmDoce">
                <a href="https://www.gob.mx/insalud" target="_blank" rel="noopener"><span> www.gob.mx/insalud </span></a>
                    <br/>
                    <p>Institutos Nacionales de Salud</p>
            </div>
            <div class="dCuatro dtSeis dmDoce">
                        <a href="http://www.pediatria.gob.mx" target="_blank" rel="noopener"><span> www.pediatria.gob.mx </span></a>
                        <br/>
                        <p>Instituto Nacional de Pediatría</p>
            </div>
            <div class="dCuatro dtSeis dmDoce">
                        <a href="https://www.insp.mx/bibliotecas.html" target="_blank" rel="noopener"><span> www.insp.mx/bibliotecas.html </span></a>
                        <br/>
                        <p>Biblioteca de Virtual en Salud México</p>
            </div>

            <div class="dCuatro dtSeis dmDoce Fblanco">
                        <a href="http://www.insp.mx" target="_blank" rel="noopener"><span> www.insp.mx </span></a>
                        <br/>
                        <p>Instituto Nacional de Salud Pública</p>
            </div>
            <div class="dCuatro dtSeis dmDoce Fblanco">
                        <a href="https://medlineplus.gov/spanish/" target="_blank" rel="noopener"><span> medlineplus.gov/spanish/ </span></a>
                        <br/>
                        <p>Información de Salud de la Biblioteca Nacional de Medicina</p>
            </div>
        </div>
    </div>
</div>
</div>